import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelInput } from "../types";

export interface IPatchClientInputsMutation {
  model_id: string;
  updates: ClientModelInput[];
}

export const usePatchClientModelInputs = () => {
  return useMutation({
    mutationFn: ({ model_id, updates }: IPatchClientInputsMutation) => {
      return axios
        .patch(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/external_effects`,
          updates
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        });
    }
  });
};
